module.exports = __webpack_public_path__ + "media/images/games/fifa-20/logo-29805d41234e9a9f109fe44b9ba7e2a7.png";